export type { DefaultConfig as ImagiseCloudApiClientConfig } from './lib/providers';
export { provideDefaultClient, provideNgOpenapi } from './lib/providers';
export * from './lib';

import { EnvironmentProviders } from '@angular/core';
import { DefaultConfig, provideDefaultClient } from './lib/providers';

/** Registers the generated Imagise Cloud API client with the given base path. */
export function provideImagiseCloudApiClient(
  config: DefaultConfig
): EnvironmentProviders {
  return provideDefaultClient({
    ...config,
    basePath: config.basePath.replace(/\/+$/, ''),
  });
}
